// Shared display helpers for the henvendelser page.

export function fmtDate(d: string | null): string {
  if (!d) return '—'
  return new Date(d).toLocaleDateString('da-DK', { year: 'numeric', month: 'short', day: 'numeric' })
}

export type WhoPays = 'lejer' | 'udlejer' | 'uafklaret'

export const WHO_PAYS_OPTIONS: WhoPays[] = ['lejer', 'udlejer', 'uafklaret']

export const WHO_PAYS_LABELS: Record<string, string> = {
  lejer: 'Lejer',
  udlejer: 'Udlejer',
  uafklaret: 'Uafklaret',
}

export function whoPaysLabel(v: string | null): string {
  if (!v) return '—'
  return WHO_PAYS_LABELS[v] ?? v
}
